<div class="table" [class.highlight]="outcome === BaccaratOutcome.Tie">
    <div class="banker" [class.highlight]="outcome === BaccaratOutcome.BankerWin">
        <div class="hand-value-container">
            <div class="hand-value">{{ bankerHandValue }}</div>
        </div>
        <div class="cards-container">
            <div class="position-3">
                <div
                    class="placeholder"
                    [class.highlight]="nextCardPosition === CardPosition.BankerThirdCard"
                    [ngClass]="'card-' + cards?.[CardPosition.BankerThirdCard]"
                ></div>
            </div>

            <div
                class="position-2 placeholder"
                [class.highlight]="nextCardPosition === CardPosition.BankerSecondCard"
                [ngClass]="'card-' + cards?.[CardPosition.BankerSecondCard]"
            ></div>
            <div
                class="position-1 placeholder"
                [class.highlight]="nextCardPosition === CardPosition.BankerFirstCard"
                [ngClass]="'card-' + cards?.[CardPosition.BankerFirstCard]"
            ></div>
        </div>
    </div>
    <div class="player" [class.highlight]="outcome === BaccaratOutcome.PlayerWin">
        <div class="hand-value-container">
            <div class="hand-value">{{ playerHandValue }}</div>
        </div>
        <div class="cards-container">
            <div
                class="position-1 placeholder"
                [class.highlight]="nextCardPosition === CardPosition.PlayerSecondCard"
                [ngClass]="'card-' + cards?.[CardPosition.PlayerSecondCard]"
            ></div>
            <div
                class="position-2 placeholder"
                [class.highlight]="nextCardPosition === CardPosition.PlayerFirstCard"
                [ngClass]="'card-' + cards?.[CardPosition.PlayerFirstCard]"
            ></div>
            <div class="position-3">
                <div
                    class="placeholder"
                    [class.highlight]="nextCardPosition === CardPosition.PlayerThirdCard"
                    [ngClass]="'card-' + cards?.[CardPosition.PlayerThirdCard]"
                ></div>
            </div>
        </div>
    </div>
</div>
